// Placeholder content — düzenlenebilir. Metinleri buradan güncelleyebilirsiniz.

export const COMPANY = {
  name: "İnter Orman Ürünleri",
  tagline: "Ahşap Kaplama İthalat",
  established: "1983",
  email: "info@interorman.com.tr",
  phone: ["+90 533 390 39 79", "+90 530 970 27 10", "+90 535 017 39 69"],
  whatsapp: ["+90 533 390 39 79", "+90 530 970 27 10", "+90 537 724 59 31"],
  internationalHelp: {
    phone: "+90 535 017 39 69",
    whatsapp: "+90 537 724 59 31",
  },
  address: "Orhanlı Mah. İrfan Cad. No:14 Tuzla/İstanbul",
};

export const CATEGORIES = [
  {
    id: "kaplama-yapay",
    label: "01",
    title: "Yapay Kaplama",
    subtitle: "Yapay Kaplama",
    description:
      "[Bu bölümü kendi ürün açıklamanızla doldurun. Yapay kaplama ürün grubunuzu, uygulama alanlarını ve avantajlarını burada anlatabilirsiniz.]",
    image:
      "https://images.unsplash.com/photo-1561435354-298941a0d4a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    id: "kaplama",
    label: "02",
    title: "Kaplama",
    subtitle: "Doğal Ahşap Kaplama",
    description:
      "[Bu bölümü kendi ürün açıklamanızla doldurun. Doğal ahşap kaplama ürünlerinizi, ağaç türlerini ve kullanım alanlarını burada anlatabilirsiniz.]",
    image:
      "https://images.unsplash.com/photo-1634672652995-ee7525bce595?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
];

export const PRODUCTS = [
  { id: 1, name: "[Ürün Adı]", cat: "Yapay Kaplama", span: "md:col-span-8 md:row-span-2", image: "https://images.unsplash.com/photo-1582055193464-943584223be1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" },
  { id: 2, name: "[Ürün Adı]", cat: "Kaplama", span: "md:col-span-4 md:row-span-1", image: "https://images.unsplash.com/photo-1736506159776-22ca388780fa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" },
  { id: 3, name: "[Ürün Adı]", cat: "Yapay Kaplama", span: "md:col-span-4 md:row-span-1", image: "https://images.unsplash.com/photo-1621295693450-080546d2ec8e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" },
  { id: 4, name: "[Ürün Adı]", cat: "Kaplama", span: "md:col-span-5 md:row-span-1", image: "https://images.unsplash.com/photo-1590635022668-81cc8696a19d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: 5, name: "[Ürün Adı]", cat: "Kaplama", span: "md:col-span-7 md:row-span-1", image: "https://images.unsplash.com/photo-1611600700192-d87eaeed4f81?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" },
  { id: 6, name: "[Ürün Adı]", cat: "Yapay Kaplama", span: "md:col-span-6 md:row-span-1", image: "https://images.unsplash.com/photo-1515713519566-6f9bf3b4a07a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: 7, name: "[Ürün Adı]", cat: "Kaplama", span: "md:col-span-6 md:row-span-1", image: "https://images.unsplash.com/photo-1634672652995-ee7525bce595?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
];

export const CHAPTERS = [
  {
    num: "01",
    title: "Biz Kimiz?",
    body: "İnter Orman, dünyanın en kaliteli ahşap ürünlerini sizlerin beğenisine sunan ve kaliteyi önemseyen bir firmadır. Çevreye duyarlı, sosyal, kültürel ve düşünsel değerlerimizin bütünlüğüyle oluşturduğumuz çizgimizle evrensel ölçülerde bir firma olma yolunda kendimizden emin adımlarla ilerliyoruz.",
  },
  {
    num: "02",
    title: "Misyonumuz",
    body: "Globalleşen günümüz dünyasında öncü olabilmek; siz müşterilerimize istek ve ihtiyaçlarınız doğrultusunda kaliteli ürünler ve pazar stratejileri sunarak alım-satım süreçlerini rekabetçi, hızlı, kolay, güvenilir ve verimli hale getirip sizleri rakiplerinizin karşısında güçlü konuma getirebilmektir.",
  },
  {
    num: "03",
    title: "Amacımız",
    body: "İnter Orman Ürünleri olarak amacımız sağlam, dekoratif ve uzun ömürlü malzemeleri zengin çeşitlilik içinde ihtiyaç duyulduğu an sizlere sunmaktır. İthal ettiğimiz ürünlerimizin var olan standartlar üzerinde ve stoklu olarak bulundurulması en önemli çalışma prensibimizdir. Projelerinizde, bilgi ve deneyimlerimizden yararlanarak hızlı ve zamanında teslimatla beklentilerinizi karşılayacak ideallere ulaştığımızı ve bu çizgide devamlı olarak kendimizi geliştirmeye devam ettiğimizi mutlulukla ifade edebiliriz.",
  },
];

export const STATS = [
  { value: "2.500.000m²+", label: "Kaplama" },
  { value: "40+", label: "Yıllık Tecrübe" },
  { value: "%100", label: "Kalite" },
];
